import * as yup from 'yup';
import _keys from 'lodash/keys';
import _get from 'lodash/get';

const validate = async (schema, data) => {
  try {
    await schema.validate(data, { abortEarly: false });
    return null;
  } catch (err) {
    const errors = {};

    err.inner.forEach((e) => {
      errors[e.path] = e.message;
    });

    return errors;
  }
};

const generateSchema = (schema) => yup.object().shape(schema);

const setErrors = (setError, errors) => {
  _keys(errors).forEach((key) => {
    setError(key, { type: 'server', message: _get(errors, `${key}`, '') });
  });
};

const yupResolver = {
  ...yup,
  validate,
  generateSchema,
  setErrors,
};

export default yupResolver;
